import { Col, Flex, Input, Radio, Row, Space } from "antd";
import { Field, Form, Formik } from "formik";
import { Translation, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Logo from "assets/images/logo_final_1_1.png";

import { Button } from "components/elements";
import { AuthBackground } from "components/layouts";
import schema, { initialValues } from "../schemas/ResetPasswordSchema";
import { isPassword } from "utils/validators";
import * as Yup from "yup";

import styles from "../styles/Reset.module.css";
import { ExclamationCircleFilled, ExclamationCircleTwoTone } from "@ant-design/icons";

const ResetPassword = ({ isLoading = false, doReset = () => { } }) => {

  const { t } = useTranslation();

  const ResetPasswordSchema = Yup.object().shape({
    newPassword: Yup.string()
      .min(8, t('reset.password-must-be-at-least-8-characters'))
      .test("is-password", t('reset.password-is-invalid'), (value) => isPassword(value))
      .required(t('reset.password-is-required')),
    newPasswordConfirm: Yup.string()
      .required(t('reset.please-confirm-your-password'))
      .oneOf([Yup.ref("newPassword"), null], t('reset.passwords-must-match')),
  });

  function matchColorText(bool) {
    return !bool ? 'grey' : 'black'
  }

  function matchColorDot(bool) {
    return !bool ? 'grey' : '#2CADE7'
  }

  return (
    <AuthBackground showLanguageSwitcher>
      <div className={styles.container}>
        <img src={Logo} className={styles.logo} alt="flow hr logo" />

        <Formik
          initialValues={initialValues}
          onSubmit={doReset}
        // validationSchema={ResetPasswordSchema}
        >
          {({ isValid, values }) => {
            return (
              <Form className={styles.formContainer}>
                <p className={styles.header}>
                  <Translation>{(t) => t("reset.setting_password")}</Translation>
                </p>
                {/* <p className={styles.subHeader}>
                  <Translation>{(t) => t("sub_header_reset")}</Translation>
                </p> */}
                <Field name={"newPassword"}>
                  {({ field, meta }) => (
                    <div>
                      <Input.Password
                        size="large"
                        type="text"
                        placeholder={t('reset.new-password')}
                        className={styles.input}
                        {...field}
                      />
                      {meta.touched && meta.error && (
                        <div className="error">{meta.error}</div>
                      )}
                    </div>
                  )}
                </Field>
                <Field name="newPasswordConfirm">
                  {({ field, meta }) => (
                    <div>
                      <Input.Password
                        size="large"
                        type="text"
                        placeholder={t('reset.confirm-password')}
                        className={styles.input}
                        {...field}
                      />
                      {meta.touched && meta.error && (
                        <div className="error">{meta.error}</div>
                      )}
                    </div>
                  )}
                </Field>
                <Flex>
                  <Row gutter={10} justify={"space-between"} >
                    <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.match("(?=.*[A-Z])")) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.match("(?=.*[A-Z])")) }}></div>{t("common.capital_pass")}</Space></Col>
                    <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.match("(?=.*[a-z])")) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.match("(?=.*[a-z])")) }}></div>{t("common.lower_pass")}</Space></Col>
                    <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.match("(?=.*[0-9])")) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.match("(?=.*[0-9])")) }}></div>{t("common.number_pass")}</Space></Col>
                    <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.length >= 8) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.length >= 8) }}></div>{t("common.at least_8")}</Space></Col>
                    <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.match("(?=.*[^a-zA-Z0-9_])")) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.match("(?=.*[^a-zA-Z0-9_])")) }}></div>{t("common.special_char")}</Space></Col>
                    {/* <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.length > 0 && values?.newPasswordConfirm?.length > 0 && values?.newPassword == values?.newPasswordConfirm) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.length > 0 && values?.newPasswordConfirm?.length > 0 && values?.newPassword == values?.newPasswordConfirm) }}></div>รหัสผ่านไม่ตรงกัน</Space></Col> */}
                  </Row>

                </Flex>

                <Button
                  className={styles.button}
                  size="large"
                  htmlType="submit"
                  disabled={!(
                    values?.newPassword?.match("(?=.*[A-Z])")
                    && values?.newPassword?.match("(?=.*[a-z])")
                    && values?.newPassword?.match("(?=.*[0-9])")
                    && values?.newPassword?.length >= 8
                    && values?.newPassword?.match("(?=.*[^a-zA-Z0-9_])")
                    && values?.newPassword?.length > 0 && values?.newPasswordConfirm?.length > 0 && values?.newPassword == values?.newPasswordConfirm
                  )}
                >
                  <p className={styles.textbuttonConfirm}>{t('reset.confirm')}</p>
                </Button>
                <Link to="/login">
                  <Button
                    className={styles.buttonCancel}
                    type="default"
                    size="large"
                    htmlType="button"
                  >
                    <p className={styles.textbuttonCancel}>{t('reset.cancel')}</p>
                  </Button>
                </Link>
              </Form>
            );
          }}
        </Formik>
      </div>
    </AuthBackground>
  );
};

export default ResetPassword;
